import * as actionType from "../constants";
import { getBoardHistory } from "./update-single-row";
import * as commonData from "../Common";

export const removeMonitor = (inputs, any) => async (dispatch) => {
  const api = commonData.commonData().apiUrl;
  try {
    const resp = await fetch(`${api}tattle/remove-monitoring`, {
      method: "post",
      body: JSON.stringify(inputs),
    });

    const redata = await resp.json();
    if (redata.code === 200) {
      if (any == "status") {
        return redata;
      }
      dispatch({
        type: actionType.REMOVE_MONITOR,
        payload: redata.data.attribute_value,
      });
      dispatch(
        getBoardHistory({
          customer_tattle_uuid: +inputs.customer_tattle_uuid,
          attribute_set_key: inputs.attribute_set_key,
          app_token: inputs.app_token,
        })
      );
      return redata;
    }
  } catch (error) {
    console.log(error);
  }
};
